import { ReactElement } from 'react';
import { color } from '@op/opds.tokens';
import { useLocale } from '@op/opds.opux';
import LevelBar from './LevelBar';
import { useIsMobile } from '../../../util/mediaQuery';
import styles from './IndustrySpeficicGraphWrapper.module.scss';

const SectionLabels = (): ReactElement => {
  return (
    <div className={styles.sectionLabels} aria-hidden="true">
      <p>-50%</p>
      <p>-25%</p>
      <p>0%</p>
      <p>+25%</p>
      <p>+50%</p>
    </div>
  );
};

const LevelBarItem = ({ name, value }: { name: string; value: number }): ReactElement => {
  const locale = useLocale();
  const numberFormatter = new Intl.NumberFormat(locale, {
    maximumFractionDigits: 2,
    style: 'percent',
    signDisplay: 'exceptZero',
  });
  return (
    <>
      <dt key={value} className={styles.term}>
        <LevelBar
          value={value}
          color={value >= 0 ? color.palette.green[500] : color.palette.red[700]}
          max={100}
        />
        {name}
      </dt>
      <dd className="sr-only">{numberFormatter.format(value / 100)}</dd>
    </>
  );
};

interface Props {
  events: string[];
  data: Array<{ name: string; value: number }>;
  listAriaLabel: string;
}

const IndustrySpeficicGraphWrapper = (props: Props): ReactElement => {
  const { data, events, listAriaLabel } = props;
  const isMobile = useIsMobile();
  return (
    <>
      <div className="opux-v6__opds">
        <ul className={styles.eventList}>
          {events.map((event) => {
            return <li key={event}>{event}</li>;
          })}
        </ul>
      </div>
      <div className={styles.sectionLabels}>
        <SectionLabels />
        {!isMobile && <SectionLabels />}
      </div>
      <dl className={styles.industrylist} aria-label={listAriaLabel}>
        {data.map((item) => (
          <LevelBarItem key={item.name} name={item.name} value={item.value} />
        ))}
      </dl>
    </>
  );
};

export default IndustrySpeficicGraphWrapper;
